var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserPurple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-02"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.99993 7.5C4.41489 7.5 3.00532 8.26532 2.10792 9.45298C1.91478 9.7086 1.81821 9.83641 1.82136 10.0091C1.8238 10.1426 1.90761 10.3109 2.01261 10.3933C2.14852 10.5 2.33686 10.5 2.71354 10.5H9.28631C9.66299 10.5 9.85133 10.5 9.98724 10.3933C10.0922 10.3109 10.176 10.1426 10.1785 10.0091C10.1816 9.83641 10.0851 9.7086 9.89193 9.45298C8.99453 8.26532 7.58496 7.5 5.99993 7.5Z",
    stroke: "#5925DC",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99993 6C7.24257 6 8.24993 4.99264 8.24993 3.75C8.24993 2.50736 7.24257 1.5 5.99993 1.5C4.75728 1.5 3.74993 2.50736 3.74993 3.75C3.74993 4.99264 4.75728 6 5.99993 6Z",
    stroke: "#5925DC",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPurple);
export default __webpack_public_path__ + "static/media/userPurple.51d4ee1df229da0469662486d7655f1f.svg";
export { ForwardRef as ReactComponent };